import React from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idQuizesDelete } from '../../../adminSlice';

export default class DeleteInputFormsForQuizes  extends React.Component {
    constructor(props) {
        super(props);
        
       
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;

        const item = {
            quiz_id: this.props.adminState.selectedId,
           // main_name: this.state.userInputContent,
            
        }
        console.log(item);
        dispatch(idQuizesDelete(item));  
}


// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
       return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openDeleteInputFormsForQuizes) {
        return(
            <div className="InputFormsForQuizes">
                <p className='p-text'>id: {this.props.adminState.selectedId}</p>
                <p className='p-text'>Тест: {this.props.adminState.dataQuizesId.map(item => {
              // console.log(item)
                if (item.id === Number(this.props.adminState.selectedId))
               //console.log(item.label)
                {return item.text;} else return null;
                })}
                </p>
                


             <p>Вы действительно хотите удалить данный тест?</p>
             <p className='p-text'>(Удалить возможно только <strong> пустой</strong> тест)</p>
             <button onClick={this.onSend}>Да</button>
             <button onClick={this.onClose}>Отмена</button>
            </div>
        )
     } else return null;
       
     

        
    }
}